<div class="tab-content match-summary premium-timeline-container">
    @for (timelinePeriod of data; track $index) {
    <div
        class="tab-pane show active"
        id="tab-match-summary-10-content"
        role="tabpanel"
        aria-labelledby="tab-match-summary-10"
    >
        <h6
            class="text-center text-uppercase match-summary__head dropdown-toggle"
            data-toggle="collapse"
            [attr.href]="'#collapsePremiumTimeline' + $index"
            role="button"
            aria-expanded="false"
            [attr.aria-controls]="'collapsePremiumTimeline' + $index"
        >
            {{
                'web.' + sportName + '_' + timelinePeriod.period_type + '_' + timelinePeriod.period_number
                    | lowercase
                    | translate
            }}
        </h6>
        <div class="collapse show" [attr.id]="'collapsePremiumTimeline' + $index">
            @for (timeline of timelinePeriod.timelines; track $index) {
            <div class="">
                <div
                    data-toggle="collapse"
                    [attr.href]="'#collapsePremiumTimelineEvent' + timeline.id"
                    role="button"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapsePremiumTimelineEvent' + timeline.id"
                    class="premium-timeline d-flex align-items-center no-gutters border-top py-1 px-1 small ng-star-inserted collapsed"
                >
                    <div class="px-2">
                        <i class="fa timeline-chevron"></i>
                    </div>
                    <div class="px-1">
                        @if (timeline.offensive_participant.image !== null) {
                        <img
                            [src]="timeline.offensive_participant.image"
                            [alt]="timeline.offensive_participant.name"
                            height="40"
                            width="40"
                            style="object-fit: contain"
                            class="mr-1"
                        />
                        } @if (timeline.offensive_participant.image === null) {
                        <img
                            [src]="'/img/sports/' + sportName + '.png'"
                            [alt]="timeline.offensive_participant.name"
                            height="40"
                            width="40"
                            style="object-fit: contain"
                            class="mr-1"
                        />
                        }
                    </div>
                    <div class="flex-grow-1">
                        <div class="font-0-8x font-weight-bold">
                            {{ 'web.' + sportName + '_end_reason_' + timeline.end_reason | translate }}
                        </div>
                        <div class="text-muted small">
                            {{ timeline.play_count }} {{ 'web.plays' | translate }}, {{ timeline.gain }}
                            {{ 'web.yards' | translate }}, {{ timeline.duration }}
                        </div>
                    </div>
                    @if (timeline.home_points !== 0 || timeline.away_points !== 0) {
                    <div class="pr-2 text-center">
                        <div class="text-muted small">
                            {{ timeline.offensive_participant.alias }}
                        </div>
                        <div class="font-weight-bold font-1x emph-text-node">
                            +{{ timeline.home_points !== 0 ? timeline.home_points : timeline.away_points }}
                        </div>
                    </div>
                    }
                    <div class="text-center">
                        <div class="font-weight-bold font-1-2x">
                            <div class="font-weight-normal ng-star-inserted d-flex score">
                                <div
                                    class="font-1-2x ng-star-inserted home"
                                    [class.emph-text-node]="timeline.home_points !== 0"
                                    [class.text-bold]="timeline.home_points !== 0"
                                >
                                    {{ timeline.home_score }}
                                </div>
                                <div class="divider">:</div>
                                <div
                                    class="font-1-2x ng-star-inserted away"
                                    [class.emph-text-node]="timeline.away_points !== 0"
                                    [class.text-bold]="timeline.away_points !== 0"
                                >
                                    {{ timeline.away_score }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collapse" [attr.id]="'collapsePremiumTimelineEvent' + timeline.id">
                    @for (event of timeline.events; track $index) {
                    <div
                        class="border-top px-2 py-1 d-flex align-items-center"
                        style="border-top-style: dotted !important"
                    >
                        <div class="px-2 text-right text-muted small" style="min-width: 73px">
                            {{ event.start_situation.clock }} -
                            {{ 'web.premium_timeline_nfl_period_number_' + event.period_number | translate }}
                        </div>
                        <div class="flex-grow-1">
                            @if (event.start_situation.down > 0) {
                            <div class="font-0-8x font-weight-bold">
                                {{ event.start_situation.down | nth }} & {{ event.start_situation.yfd }}
                                {{ 'web.at' | translate }} {{ event.start_situation.location.participant.alias }}
                                {{ event.start_situation.location.yardline }}
                            </div>
                            }
                            <div class="font-0-8x">
                                {{ event.description }}
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
        </div>
    </div>
    }
</div>
